<template>
  <SkeletonLoader>
    <div class="huddle-skeleton">
      <!-- Header -->
      <div class="sk-header">
        <div class="sk-header-left">
          <div class="sk-line sk-line--title" style="width: 180px"></div>
          <div class="sk-rect" style="width: 150px; height: 34px"></div>
        </div>
        <div class="sk-header-actions">
          <div class="sk-rect" style="width: 200px; height: 32px"></div>
          <div class="sk-rect" style="width: 160px; height: 32px"></div>
          <div class="sk-circle sk-circle--md"></div>
        </div>
      </div>

      <!-- Charts Row -->
      <div class="sk-charts-row">
        <div v-for="chart in charts" :key="chart.id" class="sk-chart-card">
          <div class="sk-chart-card-inner">
            <div class="sk-line" :style="{ width: chart.titleWidth }"></div>
            <div class="sk-rect" style="width: 100%; height: 120px; margin-top: 12px"></div>
          </div>
        </div>
      </div>

      <!-- Production Table -->
      <div class="sk-table-card">
        <!-- Table Header -->
        <div class="sk-row sk-table-header">
          <div class="sk-col sk-col--name">
            <div class="sk-line sk-line--sm" style="width: 70px"></div>
          </div>
          <div v-for="col in headerColumns" :key="col.id" class="sk-col sk-col--value hide-mobile">
            <div class="sk-line sk-line--sm" :style="{ width: col.width }"></div>
          </div>
        </div>

        <!-- Table Rows -->
        <div v-for="row in tableRows" :key="row.id" class="sk-row sk-table-row">
          <div class="sk-col sk-col--name">
            <div class="sk-circle sk-circle--sm"></div>
            <div class="sk-line" :style="{ width: row.nameWidth }"></div>
          </div>
          <div v-for="(val, idx) in row.values" :key="idx" class="sk-col sk-col--value hide-mobile">
            <div class="sk-line" :style="{ width: val }"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue'

export default {
  name: 'HuddleSkeleton',
  components: { SkeletonLoader },
  data () {
    return {
      charts: [
        { id: 1, titleWidth: '160px' },
        { id: 2, titleWidth: '140px' },
        { id: 3, titleWidth: '120px' },
        { id: 4, titleWidth: '150px' }
      ],
      headerColumns: [
        { id: 1, width: '80px' },
        { id: 2, width: '60px' },
        { id: 3, width: '70px' },
        { id: 4, width: '90px' },
        { id: 5, width: '65px' }
      ],
      tableRows: [
        { id: 1, nameWidth: '110px', values: ['50px', '65px', '45px', '70px', '55px'] },
        { id: 2, nameWidth: '130px', values: ['60px', '40px', '55px', '50px', '65px'] },
        { id: 3, nameWidth: '95px', values: ['45px', '70px', '60px', '40px', '50px'] },
        { id: 4, nameWidth: '120px', values: ['55px', '50px', '40px', '65px', '45px'] },
        { id: 5, nameWidth: '105px', values: ['65px', '45px', '70px', '55px', '60px'] },
        { id: 6, nameWidth: '140px', values: ['40px', '60px', '50px', '45px', '70px'] }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.huddle-skeleton {
  padding: 20px;
}

/* Header */
.sk-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  flex-wrap: wrap;
  gap: 12px;
}

.sk-header-left {
  display: flex;
  align-items: center;
  gap: 16px;

  .sk-line--title {
    margin-bottom: 0;
  }
}

.sk-header-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Charts Row */
.sk-charts-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
}

.sk-chart-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.sk-chart-card-inner {
  padding: 16px;
}

/* Production Table */
.sk-table-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.sk-table-header {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.sk-table-row {
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }
}

.sk-col--name {
  flex: 2;
  display: flex;
  align-items: center;
  gap: 10px;

  .sk-line {
    margin-bottom: 0;
  }
}

.sk-col--value {
  flex: 1;

  .sk-line {
    margin-bottom: 0;
  }
}

/* Responsive: Tablet */
@media (max-width: 991px) {
  .sk-charts-row {
    grid-template-columns: repeat(2, 1fr);
  }

  .sk-header-actions {
    .sk-rect:first-child,
    .sk-rect:nth-child(2) {
      width: 140px !important;
    }
  }
}

/* Responsive: Mobile */
@media (max-width: 575px) {
  .sk-charts-row {
    grid-template-columns: 1fr;
  }

  .sk-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .sk-header-actions {
    flex-wrap: wrap;
  }

  .hide-mobile {
    display: none;
  }

  .sk-col--name {
    flex: 1;
  }
}
</style>
